import AdminProductDetails from './AdminProductDetails';
import AdminProducts from './AdminProducts';

export {
    AdminProductDetails,
    AdminProducts,
};

export default AdminProducts;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Products/index.tsx